export default __webpack_public_path__ + "936c411eab1f749e03e0d4f38adfcddd.png";